import type { Unit } from "./unit";

export enum UnitCategory {
  LOG = 'EFactory/Logistic',
  REC = 'EFactory/Recons',
  INF = 'EFactory/Infantry',
  ART = 'EFactory/Art',
  TNK = 'EFactory/Tanks',
  AA = 'EFactory/DCA',
  HEL = 'EFactory/Helis',
  AIR = 'EFactory/Planes',
  DEFENSE = 'EFactory/Defense',
}

export enum Country {
  BEL = "BEL",
  CAN = "CAN",
  FR = "FR",
  UK = "UK",
  RFA = "RFA",
  US = "US",
  SOV = "SOV",
  DDR = "DDR",
  ESP = "ESP",
  POL = "POL",
  TCH = "TCH",
  NL = "NL",
  LUX = "LUX",
  DK = "DK",
}

export interface CostMatrix {
  name: string;
  matrix: MatrixRow[];
}

export interface MatrixRow {
  name: UnitCategory;
  activationCosts: number[];
}

export interface Pack {
  packDescriptor: string;
  unitDescriptor: string;
  availableWithoutTransport: boolean;
  availableTransportList?: string[];
  numberOfUnitsInPack: number;
  numberOfUnitInPackXPMultiplier: number[];
  numberOfCards: number;
}

export interface Division {
  id: number;
  name: string;
  descriptor: string;
  alliance: string;
  availableForPlay: boolean;
  country: Country;
  tags: string[];
  maxActivationPoints: number;
  costMatrix: CostMatrix;
  packs: Pack[];
}

export interface DivisionsMap {
  [key: string]: Division;
}

export type DeckUnit = {
  veterancy: number;
  transport?: Unit;
  pack: Pack;
};

export type GroupedPacks = {
  [key in UnitCategory]: Pack[];
};

export type GroupedPacksByCategory = {
  [key in UnitCategory]: GroupedPacksByUnitCategory;
};

export type GroupedPacksByUnitCategory = {
  [key: string]: Pack[];
};

export type GroupedDeckUnitsByDescriptor = {
  [key: string]: DeckUnit[];
};

export type GroupedDeckUnits = {
  [key in UnitCategory]: DeckUnit[];
};

export type SlotCosts = {
  [key in UnitCategory]: number[];
};

export interface PackMap {
  [key: string]: Pack;
}

export type UnitMap = {
  [key: string]: Unit;
};

